import script from "./TextScroll.vue?vue&type=script&setup=true&lang=js"
export * from "./TextScroll.vue?vue&type=script&setup=true&lang=js"

import "./TextScroll.vue?vue&type=style&index=0&id=5c98c06f&lang=scss&scoped=true"

import exportComponent from "D:\\WorkPlace\\MINE\\dataleading3.0\\app\\app-web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5c98c06f"]])

export default __exports__